import { FormulaParser } from "@datapolarna/formulaparser";
import { createLanguage, type FormulaLanguageDescription } from "./formulaLanguage";

export const formulaParser = new FormulaParser();
formulaParser.addDefaultFunctions();

const languageDescription: FormulaLanguageDescription = {
  variables: [
    {
      name: 'name',
      details: 'String',
      info: 'Name of vehicle',
    },
    {
      name: 'color',
      details: 'Color',
      info: 'Color of vehicle',
    },
  ]
};

export const language = createLanguage(formulaParser, languageDescription);
